import React from 'react';
import { useParams } from 'react-router-dom';
import { SolutionHero } from '../components/solution/SolutionHero';
import { ChallengeCards } from '../components/solution/ChallengeCards';
import { HelpRows } from '../components/solution/HelpRows';
import { JourneyTimeline } from '../components/solution/JourneyTimeline';
import { ResultsBand } from '../components/solution/ResultsBand';
import { ProductsUsed } from '../components/solution/ProductsUsed';
import { PlanRecommendation } from '../components/solution/PlanRecommendation';
import { RelatedSolutions } from '../components/solution/RelatedSolutions';
import { ProductTestimonial } from '../components/product/ProductTestimonial';
import { ProductFaq } from '../components/product/ProductFaq';
import { ProductCta } from '../components/product/ProductCta';
import { solutionCatalog } from '../data/solutions/catalog';
import { solutionPages } from '../data/solutions';
import { NotFound } from './NotFound';
export function SolutionPage() {
  const {
    slug = ''
  } = useParams();
  const page = solutionPages[slug];
  const summary = solutionCatalog[slug];
  if (!page || !summary) return <NotFound data-id="element-2227" data-mp="1g942m4r6vwm" />;
  return <main data-id="element-2228" data-mp="1jn9k38prl8a">
      <SolutionHero summary={summary} headline={page.hero.headline} subheadline={page.hero.subheadline} card={page.hero.card} data-id="element-2229" data-mp="1jdiecbxn810" />
      <ChallengeCards items={page.challenges} data-id="element-2230" data-mp="bf84xija1n92" />
      <HelpRows items={page.helps} data-id="element-2231" data-mp="39xm2sx4awsi3" />
      <JourneyTimeline heading={page.journey.heading} subheading={page.journey.subheading} items={page.journey.items} data-id="element-2232" data-mp="39yotb3xposxh" />
      <ResultsBand heading="What changes with Kayko" items={page.results} data-id="element-2233" data-mp="3jvjr1km5upap" />
      <ProductTestimonial testimonial={page.testimonial} data-id="element-2234" data-mp="3ju8k5bxf51fd" />
      <ProductsUsed keys={page.products} data-id="element-2235" data-mp="3omic0xi3gbka" />
      <PlanRecommendation plan={page.plan.name} audience={page.plan.audience} data-id="element-2236" data-mp="3oocum55w7rl7" />
      <ProductFaq heading="Frequently asked questions" items={page.faq} data-id="element-2237" data-mp="2r6cswmqmc1pz" />
      <RelatedSolutions slugs={page.related} data-id="element-2238" data-mp="2w55yzu3ksqg4" />
      <ProductCta headline={page.cta.headline} subheadline={page.cta.subheadline} data-id="element-2239" data-mp="2w3urpkax90k9" />
    </main>;
}